<template>
  <div class="layout-pc-body">

    <HeaderPc v-if="isDesktop()" />
    <HeaderPhone v-if="isPhone()" />

    <router-view />

    <FooterPc v-if="$route.name !== 'home' && isDesktop()" />
    <FooterPhone v-if="$route.name !== 'home' && isPhone()" />

    <!--这里是手机版的导航-->
    <div class="menu-mask" v-if="showMask">
      <div class="menu-mask-top">
        <!--当前位置-->
        <span @click="goHome">首页</span>
        <img @click="closeMask" class="close" src="../assets/mask/guanbi_home_m.png" alt="">
      </div>
      <div class="menu-mask-silder">
        <div class="silder-box">
          <template v-for="(item,index) in menuList">
            <div class="basic" @click="goOtherPage(item,index)" :class="item.children && item.children.length > 0 ? 'parents' : ''">{{ item.name }}</div>
            <template v-if="item.children && item.children.length > 0">
              <div class="children">
                <ul>
                  <template v-for="(citem,cindex) in item.children">
                    <li @click="goOtherDetailPage(citem,cindex)">{{ citem.name }}</li>
                  </template>
                </ul>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import HeaderPc from '../components/HeaderPc'
  import HeaderPhone from '../components/HeaderPhone'
  import FooterPc from '../components/FooterPc'
  import FooterPhone from '../components/FooterPhone'
  import { mixinDevice } from "../utils/mixin";

  export default {
    name: "layout-pc",
    mixins: [mixinDevice],
    data () {
      return {
        menuList: [
          {
            name: '关于我们',
            children:[
              {name: '公司简介',path: 'company',title: 'company'},
              {name: '加入我们',path: 'jion',title: 'company'}
            ]
          },
          {
            name: '解决方案',
            children: [
              {name: '飞联网',path: 'internet',title:'solution'},
              {name: '飞联网旅客服务',path: 'traveler',title:'solution'},
              {name: '飞联网航空公司服务',path: 'airway',title:'solution'},
            ]
          },
          {
            name: '联系方式'
          },
        ],
        showMask: false
      }
    },
    components: {
      HeaderPc,
      FooterPc,
      HeaderPhone,
      FooterPhone,
    },
    methods: {
      open () {
        this.showMask = true;
      },
      closeMask () {
        this.showMask = false;
      },
      goHome () {
        this.closeMask();
        this.$store.commit('SET_BANNER_INDEX', 0);
        if (this.$route.name !== 'home') return this.$router.push('/');
      },
      goOtherPage (item,index) {
        this.closeMask();
        this.$store.commit('SET_BANNER_INDEX', index + 1);
        if (item.name === '首页' || item.name === '联系方式') {
          if (this.$route.name !== 'home') {
            this.$router.push('/')
          }
        }
      },
      goOtherDetailPage (item,index) {
        const { path,title } = item;
        this.closeMask();
        if (title === 'solution') {
          let params = {
            path,
            index
          };
          this.$store.commit('SET_SOLUTION_PARAMS', params);
          this.$store.commit('SET_BANNER_INDEX', 1);
          if (this.$route.name === 'solution') return false;
          this.$router.push({name: 'solution'})
        } else {
          this.$store.commit('SET_COMPANY_INDEX',index);
          this.$store.commit('SET_BANNER_INDEX', 2);
          if (this.$route.name === 'company') return false;
          this.$router.push({name: 'company'});
        }
      }
    }
  }
</script>

<style scoped>
.layout-pc-body{
  width: 100%;
  height: 100%;
}
  .menu-mask{
    width:100vw;
    height:100vh;
    background:rgba(7,16,16,1);
    opacity:0.89;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;
    font-size:32px;
    font-family:SourceHanSansCN-Regular,SourceHanSansCN;
    font-weight:400;
    color:rgba(255,255,255,1);
    padding: 30px 40px;
    box-sizing: border-box;
  }
  .menu-mask-silder{
    margin-top: 78px;
  }
  .menu-mask-top{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .close{
    width: 50px;
    height: 50px;
  }
  .parents{
    font-size:32px;
    font-family:SourceHanSansCN-Regular,SourceHanSansCN;
    font-weight:400;
    color:rgba(0,210,219,1);
    line-height:48px;
  }
  .children{
    padding: 0 74px;
    box-sizing: border-box;
  }
  .children ul li{
    margin-bottom: 45px;
  }
  .basic{
    margin-bottom: 45px;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/layout-pc.vue